// src/App.js
//diay

import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import ProtectedRoute from './components/ProtectedRoute';
import ClientList from './components/ClientList';
import MyTraining from './components/MyTraining';
import TimerModal from './components/TimerModal';

// Importación de todas las páginas
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import Training from './components/Training';
import Nutrition from './components/Nutrition';
import CalendarPage from './components/Calendar'; // <-- Renombrado para evitar confusión con el componente Calendar
import Logbook from './components/Logbook';
import Messages from './components/Messages';
import ExerciseLibrary from './components/ExerciseLibrary'; 
import ProfileSettings from './components/ProfileSettings';
import ProgramList from './components/ProgramList'; 
import ProgramCreate from './components/ProgramCreate';
import ExerciseEdit from './components/ExerciseEdit';
import ClientDetail from './components/ClientDetail';
import ExerciseDetail from './components/ExerciseDetail';
import { AnimatePresence } from 'framer-motion'; 
import AnimatedPage from './components/AnimatedPage'
import ProgramEdit from './components/ProgramEdit';
import MyProgress from './components/MyProgress';
import NutritionPlanList from './components/NutritionPlanList';
import NutritionPlanCreate from './components/NutritionPlanCreate';
import NutritionPlanEdit from './components/NutritionPlanEdit';
import Achievements from './components/Achievements';
import AchievementsManage from './components/AchievementsManage';
import Manual from './components/Manual';
import About from './components/About';
import AdminUsers from './components/AdminUsers';
import ReminderTemplates from './components/ReminderTemplates';
import CoachReminders from './components/CoachReminders';
import MotivationalQuotes from './components/MotivationalQuotes';
import LicenseActivationPage from './components/LicenseActivationPage';

function App() {
  // 1. Obtenemos la ubicación actual para que AnimatePresence detecte los cambios de ruta.
  const location = useLocation();

  return (
    <Layout>
      {/* 2. AnimatePresence envuelve las rutas para controlar las animaciones de entrada y salida. */}
      <AnimatePresence mode="wait">
        {/* 3. Es crucial pasar 'location' y 'key' a Routes para que AnimatePresence funcione. */}
        <Routes location={location} key={location.pathname}>
          
          {/* --- RUTA PÚBLICA --- */}
          <Route 
            path="/login" 
            element={
              <AnimatedPage>
                <Login />
              </AnimatedPage>
            } 
          />
          <Route
            path="/license-activation"
            element={
              <AnimatedPage>
                <LicenseActivationPage />
              </AnimatedPage>
            }
          />

          {/* --- RUTAS PROTEGIDAS --- */}
          <Route 
            path="/*"
            element={
              <ProtectedRoute>
                {/* Todas las páginas protegidas también se envuelven en AnimatedPage */}
                <AnimatedPage>
                  <Routes>
                    {/* Dashboard (Coach y Cliente) */}
                    <Route path="/dashboard" element={<Dashboard />} />

                    {/* Rutas de Gestión (Coach) */}
                    <Route path="/clients" element={<ClientList />} />
                    <Route path="/admin/users" element={<AdminUsers />} />
                    <Route path="/coach/reminders" element={<CoachReminders />} />
                    <Route path="/coach/reminder-templates" element={<ReminderTemplates />} />
                    <Route path="/coach/quotes" element={<MotivationalQuotes />} />
                    <Route path="/clients/:clientId" element={<ClientDetail />} />
                    <Route path="/programs" element={<ProgramList />} />
                    <Route path="/programs/create" element={<ProgramCreate />} />
                    <Route path="/programs/:programId" element={<ProgramEdit />} />
                    <Route path="/nutrition-plans" element={<NutritionPlanList />} />
                    <Route path="/nutrition-plans/create" element={<NutritionPlanCreate />} />
                    <Route path="/nutrition-plans/:planId" element={<NutritionPlanEdit />} />
                    <Route path="/exercises/:exerciseId/edit" element={<ExerciseEdit />} />

                    {/* Rutas Comunes (Coach y Cliente) */}
                    <Route path="/exercises" element={<ExerciseLibrary />} />
                    <Route path="/exercises/:exerciseId" element={<ExerciseDetail />} />
                    <Route path="/profile-settings" element={<ProfileSettings />} />
                    <Route path="/messages" element={<Messages />} />

                    {/* Rutas Principales del Cliente */}
                    <Route path="/my-training" element={<MyTraining />} />
                    <Route path="/my-progress" element={<MyProgress />} />
                    <Route path="/achievements" element={<Achievements />} />
                    <Route path="/training" element={<Training />} />
                                        <Route path="/achievements" element={<Achievements />} />
                                        <Route path="/achievements/manage" element={<AchievementsManage />} />
                                        <Route path="/manual" element={<Manual />} />
                                        <Route path="/about" element={<About />} />
                                        <Route path="/training" element={<Training />} />
                    <Route path="/nutrition" element={<Nutrition />} />
                    <Route path="/calendar" element={<CalendarPage />} />
                    <Route path="/logbook" element={<Logbook />} />

                    {/* Redirecciones por defecto */}
                    <Route path="/" element={<Navigate to="/dashboard" replace />} />
                    <Route path="*" element={<Navigate to="/dashboard" replace />} />
                  </Routes>
                </AnimatedPage>
              </ProtectedRoute>
            } 
          />
        </Routes>
      </AnimatePresence>
      <TimerModal />
    </Layout>
  );
}

export default App;